import { Customer, api } from "./customers";

export interface DashboardCustomersResponse {
  status: string;
  message: string;
  total_count: number;
  total_pages: number;
  current_page: number;
  data: Customer[];
  per_page: number;
  prev_page: number;
  nextPage: number;
}
export interface WhatsappSetting {
  id: number;
  apiKey: string;
  appName: string;
  channel: string;
  sourceMobileNumber: string;
}
export interface FacebookSetting {
  id: number;
  userAccountId: string;
  campaignId: string;
  accessToken: string;
}
export interface Templatesetting {
  id: number;
  templateName: string;
  templateBody: string;
  templateId: string;
}
export interface GoogleAnalyticsById {
  status: string;
  message: string;
  data?: any;
}
type DasboardCustomersResponse = DashboardCustomersResponse[];
type GoogleAnalyticsByIdResponse = GoogleAnalyticsById[];

export const IntegrationApi = api.injectEndpoints({
  endpoints: (build) => ({
    addGoogleAnalytics: build.mutation<
      GoogleAnalyticsByIdResponse,
      Partial<GoogleAnalyticsByIdResponse>
    >({
      query: (body) => ({
        url: `saveCredentials`,
        method: "POST",
        body,
      }),
      transformResponse: (
        response: { data: GoogleAnalyticsByIdResponse },
        meta,
        arg
      ) => {
        return response.data;
      },
      invalidatesTags: [
        { type: "Customer", id: "LIST" },
        { type: "DasboardCustomers", id: "LIST" },
      ],
    }),
    addwhatsappsetting: build.mutation<
      WhatsappSetting,
      Partial<WhatsappSetting>
    >({
      query: (patch) => ({
        url: `whatsapp_settings`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: [
        { type: "Customer", id: "LIST" },
        { type: "DasboardCustomers", id: "LIST" },
        { type: "DashBoardCount" },
      ],
    }),
    addfacebooksetting: build.mutation<FacebookSetting,Partial<FacebookSetting>>({
      query: (patch) => ({
        url: `facebook_settings`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: [
        { type: "Customer", id: "LIST" },
        { type: "DasboardCustomers", id: "LIST" },
        { type: "DashBoardCount" },
      ],
    }),
    getWhatsappsetting: build.query<WhatsappSetting, string>({
      query: (id) => `whatsapp_settings`,
      transformResponse: (response: { data: WhatsappSetting }, meta, arg) =>
        response.data,
      providesTags: (result, error, id) => [{ type: "Customer", id }],
    }),
    getFacebooksetting: build.query<FacebookSetting, string>({
      query: (id) => `facebook_settings`,
      transformResponse: (response: { data: FacebookSetting }, meta, arg) =>
        response.data,
      providesTags: (result, error, id) => [{ type: "Customer", id }],
    }),
    getTemplatesetting: build.query<Templatesetting, string>({
      query: (id) => `template_master`,
      transformResponse: (response: any, meta, arg) => response.data,
      providesTags: (result, error, id) => [{ type: "Customer", id }],
    }),
    getGoogleAnalyticsbyId: build.query<GoogleAnalyticsByIdResponse, any>({
      query: () => `analytics`,
      providesTags: ["DashBoardLeads"],
      transformResponse: (
        response: { data: GoogleAnalyticsByIdResponse },
        meta,
        arg
      ) => response.data,
    }),
    addTemplate: build.mutation<WhatsappSetting, Partial<WhatsappSetting>>({
      query: (patch) => ({
        url: `template_master`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: [
        { type: "Customer", id: "LIST" },
        { type: "DasboardCustomers", id: "LIST" },
        { type: "DashBoardCount" },
      ],
    }),
  }),
});
export const {
  useAddGoogleAnalyticsMutation,
  useAddTemplateMutation,
  useAddwhatsappsettingMutation,
  useGetFacebooksettingQuery,
  useAddfacebooksettingMutation,
  useGetWhatsappsettingQuery,
  useGetTemplatesettingQuery,
  useGetGoogleAnalyticsbyIdQuery,
} = IntegrationApi;
